"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../_utils");
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Input = require("./Input");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('textarea');
  var className = props.className,
    disabled = props.disabled,
    readOnly = props.readOnly,
    size = props.size,
    mSize = props.mSize,
    width = props.width,
    status = props.status,
    _props$rows = props.rows,
    rows = _props$rows === void 0 ? 4 : _props$rows;
  var otherProps = (0, _utils.omit)(props, ['size', 'mSize', 'status', 'defaultValue']);
  var _React$useState = React.useState(props.value === undefined ? props.defaultValue : props.value),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var handleChange = function handleChange(e) {
    var _props$onChange;
    setValue(e.target.value);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, e);
  };
  React.useEffect(function () {
    if (props.value !== undefined) {
      setValue(props.value);
    }
  }, [props.value]);
  return /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({
    rows: rows,
    ref: ref
  }, otherProps, {
    value: (0, _Input.fixStateValue)(value),
    onChange: handleChange,
    className: (0, _classnames.default)((0, _Input.getInputClassName)(prefixCls, disabled, readOnly, size, mSize, width, status), className)
  }));
});
var _default = exports.default = TextArea;